import { render, staticRenderFns } from "./MessageContent.vue?vue&type=template&id=460b7bfc&scoped=true&"
import script from "./MessageContent.vue?vue&type=script&lang=js&"
export * from "./MessageContent.vue?vue&type=script&lang=js&"
import style0 from "./MessageContent.vue?vue&type=style&index=0&id=460b7bfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460b7bfc",
  null
  
)

export default component.exports